import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form', 'omnivore', 'omnivoreContainer', 'submitButton', 'POSIdContainer', 'omnivoreId',
    'restaurant', 'displayValue', 'simphonyLookupField', 'POSIDField', 'lookupBtn', 'simphonyLookupContainer',
    'POSIDLabel', 'simphonyLookupError', 'simphonyLookupSuccess']
  static values = {
    areSearchable: Boolean,
    restaurantId: String,
    isSimphony: Boolean
  }

  initialize() {
    let omnivore = document.getElementById('hidden_omnivore_id')
    let restaurant = document.getElementById('employee_form_restaurant_id')
    if (omnivore !== null) {
      omnivore.dataset.target = `${this.identifier}.omnivoreId`
      omnivore.dataset.action = `change->${this.identifier}#restaurantChanged`
    }
    if (restaurant !== null) {
      restaurant.dataset.target = `${this.identifier}.restaurant`
      restaurant.dataset.action = `change->${this.identifier}#restaurantChanged`
    }
  }

  areSearchableValueChanged() {
    if (this.areSearchableValue) {
      this.enableOmnivoreSelect2()
    } else {
      this.disableOmnivoreSelect2()
    }
  }

  isSimphonyValueChanged() {
    if (this.isSimphonyValue) {
      this.lookupBtnTarget.removeAttribute('disabled')
      this.simphonyLookupContainerTarget.classList.remove('hidden');
      this.POSIDLabelTarget.textContent = 'Employee Number';
    } else {
      this.lookupBtnTarget.setAttribute('disabled', 'disabled')
      this.simphonyLookupContainerTarget.classList.add('hidden');
      this.POSIDLabelTarget.textContent = 'POS ID';
    }
  }

  restaurantChanged() {
    if (this.restaurantIsSelected()) {
      this.submitButtonTarget.disabled = false
      const select2 = document.getElementById('employee_form_restaurant_id')
      const isSearchable = select2.options[select2.selectedIndex].attributes['data-employee_searchable']
      this.areSearchableValue = isSearchable.value
      this.restaurantIdValue = select2.options[select2.selectedIndex].value
      this.isSimphonyValue = select2.options[select2.selectedIndex].attributes['data-simphony'].value
      if (this.areSearchableValue) {
        this.setURL()
        this.force_reinitialize_employee_select2()
      }
    } else {
      this.submitButtonTarget.disabled = true
    }
  }

  restaurantIsSelected() {
    return this.restaurantTarget.value !== ''
  }

  employeeSelected() {
    if (!this.hasDisplayValueTarget) return
    const select2 = document.getElementById('employee_form_pos_id')
    const selected = select2.options[select2.selectedIndex].text;
    this.displayValueTarget.value = selected
  }


  disableOmnivoreSelect2() {
    this.omnivoreContainerTarget.classList.add('invisible');
    this.omnivoreContainerTarget.classList.remove('visible');
    this.POSIdContainerTarget.classList.add('visible');
    this.POSIdContainerTarget.classList.remove('invisible');
    this.omnivoreTarget.value = ''
  }

  enableOmnivoreSelect2() {
    this.omnivoreContainerTarget.classList.add('visible');
    this.omnivoreContainerTarget.classList.remove('invisible');
    this.POSIdContainerTarget.classList.add('invisible');
    this.POSIdContainerTarget.classList.remove('visible');
    this.setURL()
  }

  setURL() {
    const port = location.port ? `:${location.port}` : ''
    const url_prefix = `${location.protocol}//${location.hostname}${port}`
    const url = `${url_prefix}/sandbar/admin/restaurants/${this.restaurantTarget.value}/employee_search`

    this.omnivoreTarget.dataset.optionsUrl = url
  }

  submitForm(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.areSearchableValue) {
      this.POSIdContainerTarget.remove();
    } else {
      this.omnivoreContainerTarget.remove();
    }
    this.formTarget.submit()
  }

  force_reinitialize_employee_select2() {
    const event = new Event('select2:reinitialize')
    const select2 = document.getElementById('employee_form_omnivore_id')
    select2.dispatchEvent(event)
  }

  fetchSimphonyEmployeeID(e) {
    e.preventDefault();
    e.stopPropagation();
    this.simphonyLookupSuccessTarget.classList.add('hidden')
    this.simphonyLookupErrorTarget.classList.add('hidden')
    this.lookupBtnTarget.setAttribute('disabled', true)
    const posId = this.simphonyLookupFieldTarget.value
    const url = `/sandbar/admin/employees/simphony_lookup/${this.restaurantIdValue}/${posId}.json`
    const myRequest = new Request(url);

    fetch(myRequest)
      .then(response => response.json())
      .then(data => {
        this.lookupBtnTarget.removeAttribute('disabled')
        if (Object.prototype.hasOwnProperty.call(data, 'employeeNumber')) {
          this.simphonyLookupSuccessTarget.classList.remove('hidden')
          this.POSIDFieldTarget.value = data.employeeNumber
        } else {
          const errorText = `ERROR: Employee Not Found: ${this.simphonyLookupFieldTarget.value}`
          this.simphonyLookupErrorTarget.value = errorText
          this.simphonyLookupErrorTarget.classList.remove('hidden')
        }
      })
      .catch(console.error);
  }
}
